import React from 'react';
import { Swiper, SwiperSlide } from 'swiper/react';
import { Autoplay } from 'swiper/modules';

// Swiper styles import karna mat bhulna
import 'swiper/css';

const Brand = ({brands}) => {
 

  return (
    <section className="ith-brand-section section-space">
      <div className="container-fluid">
        <div className="row justify-content-center">
          <div className="col-xl-8">
            <div className="ith-section-title-wrapper text-center mb-50">
              <span className="ith-section-subtitle">PARTNERS</span>
              <h2 className="ith-section-title">
                Partners Who Trust Industrial Trading House
              </h2>
            </div>
          </div>
        </div>

        <div className="row">
          <div className="col-12">
            <Swiper
              modules={[Autoplay]}
              spaceBetween={30}
              slidesPerView={2}
              loop={true}
              speed={3000} // Smooth continuous effect ke liye
              autoplay={{
                delay: 0,
                disableOnInteraction: false,
              }}
              breakpoints={{
                640: { slidesPerView: 3 },
                768: { slidesPerView: 4 },
                1024: { slidesPerView: 6 },
              }}
              className="ith-brand-swiper"
            >
              {brands.map((brand, index) => (
                <SwiperSlide key={index}>
                  <div className="ith-brand-item">
                    <img src={brand.image} alt={`brand-${index}`} />
                  </div>
                </SwiperSlide>
              ))}
            </Swiper>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Brand;